module.exports = __webpack_public_path__ + "static/media/loginpage.85330707.jpg";